import { Icon } from '@iconify/react';

export function DirectExit() {
  return (
    <div className="flex flex-row h-[100dvh] justify-center">
      <div className="flex flex-col justify-center p-8">
        <h1 className="font-semibold text-3xl flex items-center gap-2">
          <span>Thank you for completing the survey</span>
          <span className="text-green-500 text-4xl">
            <Icon icon="mdi:check-circle" />
          </span>
        </h1>
        <p className="text-lg">You can close this tab.</p>
      </div>
    </div>
  );
}
